import { createSelector } from "@reduxjs/toolkit";
import { type RootState } from "features/Application/globaltypes/redux";
import { mapTagsToView } from "features/Library/Common/helpers/tagsHelper";
import { type TagsPayloadCamelPlural } from "interfaces/Tags";
import { type FormFields } from "../../types/models";
import { type DetailsState } from "../slices/DetailsSlice";

export const normalizedTagsSelector = createSelector(
  [(state: RootState): TagsPayloadCamelPlural => state.library.scorm.tags.tags],
  mapTagsToView,
);

export const formFieldsSelector = createSelector(
  [(state: RootState) => state.library.scorm.details],
  (value: DetailsState): FormFields => ({
    title: value.item.title,
    fileName: value.item.fileName,
    description: value.item.description,
    thumbnailUrl: value.item.thumbnailUrl ?? "",
    uploadedFiles: value.uploadedFiles,
  }),
);
